var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "box",
        {
          ref: "rightClickBox",
          staticClass: "right-click-box",
          style: { left: _vm.rightClickPopUpX, top: _vm.rightClickPopUpY },
          attrs: {
            background: "white",
            closable: "",
            customClass: "right-context-menu"
          },
          on: { closed: _vm.closed }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(_vm._s(_vm.$t("mapRightClick.options")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _vm.canAddStop
                ? _c(
                    "v-btn",
                    {
                      staticClass: "right-click-btn",
                      attrs: {
                        flat: "",
                        block: "",
                        small: "",
                        title: _vm.$t("mapRightClick.addDestinationToRoute")
                      },
                      on: {
                        click: function($event) {
                          return _vm.rightClickEvent("addDestinationToRoute")
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("mapRightClick.addDestinationToRoute"))
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canRoute
                ? _c(
                    "v-btn",
                    {
                      staticClass: "right-click-btn",
                      attrs: {
                        flat: "",
                        small: "",
                        block: "",
                        title: _vm.$t("mapRightClick.directionsFromHere")
                      },
                      on: {
                        click: function($event) {
                          return _vm.rightClickEvent("directionsFromPoint")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("mapRightClick.directionsFromHere")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canRoute
                ? _c(
                    "v-btn",
                    {
                      staticClass: "right-click-btn",
                      attrs: {
                        flat: "",
                        small: "",
                        block: "",
                        title: _vm.directionsToHereText
                      },
                      on: {
                        click: function($event) {
                          return _vm.rightClickEvent("directionsToPoint")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.directionsToHereText))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canAddStop
                ? _c(
                    "v-btn",
                    {
                      staticClass: "right-click-btn",
                      attrs: {
                        flat: "",
                        small: "",
                        block: "",
                        title: _vm.$t("mapRightClick.addRouteStop")
                      },
                      on: {
                        click: function($event) {
                          return _vm.rightClickEvent("addRouteStop")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("mapRightClick.addRouteStop")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canAddIsochroneCenter
                ? _c(
                    "v-btn",
                    {
                      staticClass: "right-click-btn",
                      attrs: {
                        block: "",
                        flat: "",
                        small: "",
                        title: _vm.$t("mapRightClick.addAsIsochroneCenter")
                      },
                      on: {
                        click: function($event) {
                          return _vm.rightClickEvent("addAsIsochroneCenter")
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("mapRightClick.addAsIsochroneCenter"))
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canShowInspector
                ? _c(
                    "v-btn",
                    {
                      staticClass: "right-click-btn",
                      attrs: {
                        block: "",
                        flat: "",
                        small: "",
                        title: _vm.$t("mapRightClick.inspectDataOnOSM")
                      },
                      on: {
                        click: function($event) {
                          return _vm.inspectDataOnOSM()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("mapRightClick.inspectDataOnOSM")))]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2299230a", { render: render, staticRenderFns: staticRenderFns })
  }
}